import { Breadcrumb as AntdBreadcrumb, Typography } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import { getCategoryBySlug } from "../../../lib/helpers/category";
import { getColor } from "../../resources/theme";
import { useEffect } from "react";
import { useState } from "react";
import React, { useGlobal } from "reactn";
import queryString from "query-string";
import styled from "styled-components";
import { pathOr } from "ramda";

const { Item } = AntdBreadcrumb;
const { Text } = Typography;
export const Breadcrumb = ({ office = {} }) => {
	const location = useLocation();
	const params = useParams();

	const [categories] = useGlobal("categories");
	const [lines] = useGlobal("lines");

	const { folder = null } = queryString.parse(location.search);

	const { category_id: categoryId } = office;
	const { category: categorySlug } = office;

	const { slug, name } = pathOr({}, ["byId", categoryId], categories);

	const category = getCategoryBySlug(categories, categorySlug);
	const { name: categoryName } = category || {};

	const line =
		lines.find(
			({ slug }) => params.lineslug === slug || params.line === slug
		) || {};

	const LINKS = [
		{ name: "Inicio", link: "/home" },
		{
			name: `${name || categoryName}`,
			link: `/search?category=${slug || categorySlug}`,
		},
	];

	const buildLinks = ([paramKey, _]) => {
		const links = [];
		if (
			paramKey.includes("offices") ||
			location.pathname.includes("offices") || // because sometimes it doesn't have a param named offices
			paramKey.includes("office") ||
			paramKey.includes("slug") ||
			paramKey.includes("officeslug")
		) {
			links.push({ name: office.name, link: `/offices/${office.slug}` });
			!!folder &&
				links.push({
					name: folder,
					link: `${location.pathname}${location.search}`,
				});
		}
		if (paramKey.includes("lineslug") || paramKey.includes("line")) {
			!!line.folder &&
				links.push({
					name: line.folder,
					link: `/offices/${office.slug}?folder=${line.folder}`,
				});
			links.push({
				name: line.name,
				link: `/offices/${office.slug}/lines/${line.slug}`,
			});
		}
		if (
			(paramKey.includes("id") &&
				location.pathname.includes("/ticket")) ||
			location.pathname.includes("/ticket")
		) {
			links.push({ name: "Ticket" });
		}
		if (
			(paramKey.includes("id") &&
				location.pathname.includes("/reservation")) ||
			location.pathname.includes("/reservation")
		) {
			links.push({ name: "Reserva" });
		}

		return links;
	};
	const [links, setLinks] = useState(LINKS);

	const showLogs = () => {};

	useEffect(() => {
		// showLogs();
		!!office &&
			!!line &&
			setLinks(
				Object.entries(params).reduce((acc, current) => {
					const builtLinks = buildLinks(current);
					return [...LINKS, ...builtLinks];
				}, [])
			);
	}, [location.pathname, params, office.name, line.name, line.folder]);

	return (
		<AntdBreadcrumb>
			{links.map(({ name, link }, i) => {
				const clickable =
					link && link !== `${location.pathname}${location.search}`;
				return (
					<Item key={i}>
						{name && clickable ? (
							<Link to={link}>
								<StyledText clickable={clickable}>
									{name}
								</StyledText>
							</Link>
						) : (
							<Text style={{ fontSize: "12px" }}>{name}</Text>
						)}
					</Item>
				);
			})}
		</AntdBreadcrumb>
	);
};

const StyledText = styled(Text)`
	color: ${(props) => props.clickable && getColor("primary")};
	${(props) => props.clickable && "font-weight: 600"};
	font-size: 12px;
`;
